import apisauce from "apisauce";
import { store } from "store/configureStore";
import { hotToast } from "utils";



export const BASE_URL = process.env.BASE_URL;
export class Api {
  api: any = null;
  BASE_URL = process.env.REACT_APP_cnxAPI;

  constructor() {
    this.api = apisauce.create({
      baseURL: this.BASE_URL,
    });

    this.api.addRequestTransform((request: any) => {
      const jwt: string = store.getState().user.jwt;
      request.headers["Authorization"] = `Bearer ${jwt}`
    });
  }

  async postFormData(endPoint: string, form: any) {
    this.api.setHeaders({ "Content-Type": "multipart/form-data" });
    return await this.api.post(endPoint, form).then(responseCode);
  }

  async putFormData(endPoint: string, form: FormData) {
    this.api.setHeaders({ "Content-Type": "multipart/form-data" });
    return await this.api.put(endPoint, form).then(responseCode);
  }

  async post(endPoint: string, data: object) {
    return await this.api.post(endPoint, data).then(responseCode);
  }
  async get(endpoint: string) {
    return await this.api.get(endpoint).then(responseCode);
  }
  async put(endpoint: string, data: object) {
    return await this.api.put(endpoint, data).then(responseCode);
  }
  async remove(endpoint: string, data: object) {
    return await this.api.delete(endpoint, data).then(responseCode);
  }
  async patch(endpoint: string, data: object) {
    return await this.api.patch(endpoint, data).then(responseCode);
  }
}

export const responseCode = async (response: object) => {
  const { status, data, problem }: any = response;
  
  // Si hay un problema de red o timeout
  if (problem) {
    console.error("Error de conexión:", problem);
    hotToast("Error de conexión con el servidor", "ERROR");
    return null;
  }
  
  let result;
  switch (status) {
    case 200:
      result = data;
      break;
    case 201:
      result = data;
      break;
    case 204:
      result = true;
      break;

    //Codigos de Error
    case 500:
      hotToast("Porfavor contacta a tu administrador [Error:500]", "ERROR");
      result = null;
      break;
    case 404:
      const message = typeof data === "string" ? data : "No se encontro el recurso. Porfavor contacta a tu administrador [ERROR: 404]";
      hotToast(message, "ERROR");
      result = null;
      break;
    case 401:
      hotToast("Tu sesión ah expirado", "ERROR");
      break;
    case 400:
      const message400 = typeof data === "string" ? data : "Hubo un problema al enviar la informacion, porfavor contacta a tu administrador [ERROR: 400]";
      hotToast(message400, "WAR");
      result = null;
      break;
    case 409:
      const message409 = data.message ? data.message : "Hubo un problema al enviar la informacion, porfavor contacta a tu administrador [ERROR: 409]";
      hotToast(message409, "WAR");
      result = null;
      break;
    default:
      console.error("Status code no manejado:", status, "Data:", data);
      hotToast("Error desconocido, contacta a tu administrador", "ERROR");
      result = null;
      break;
  }
  return result;
};
